import {
  actions,
  applyRef,
  KeyMap,
  useCallbackRef,
} from '@infotech-soe/erp-ui-kit';
import classNames from 'classnames';
import React, { memo, MouseEvent, useCallback, useRef } from 'react';
import { useHotkeys } from 'react-hotkeys-hook';

import { OPEN_MENU_HOTKEY } from './constants';
import { useMenuContext } from './MenuContext';
import { useBackdropStyles } from './styles';

const MenuBackdrop = () => {
  const { collapsed, sysNotificationsNumber, onToggleMenu } = useMenuContext();
  const classes = useBackdropStyles(sysNotificationsNumber);

  const backdropRef = useRef<HTMLDivElement>(null);

  const openMenuHotkeyRef = useHotkeys(
    OPEN_MENU_HOTKEY,
    () => onToggleMenu(true),
    {
      enableOnFormTags: ['INPUT', 'SELECT', 'TEXTAREA'],
      preventDefault: true,
    }
  );

  const closeApplicationMenu = useCallback(
    () => onToggleMenu(false),
    [onToggleMenu]
  );

  const closeMenuHotkeyRef = useHotkeys(
    KeyMap[actions.CANCEL],
    closeApplicationMenu,
    {
      enabled: !collapsed,
      enableOnFormTags: ['INPUT', 'SELECT', 'TEXTAREA'],
    }
  );

  const menuHotkeysRef = useCallbackRef(openMenuHotkeyRef, closeMenuHotkeyRef);

  const assingHotkeysToBody = () => applyRef(menuHotkeysRef, document.body);

  const callbackRef = useCallbackRef(backdropRef, assingHotkeysToBody);

  const handleBackdropClick = useCallback(
    (event: MouseEvent<HTMLDivElement>) => {
      if (event.target === backdropRef.current) closeApplicationMenu();
    },
    [closeApplicationMenu]
  );

  return (
    // eslint-disable-next-line jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions
    <div
      className={classNames({ [classes.backdrop]: !collapsed })}
      ref={callbackRef}
      onClick={handleBackdropClick}
    ></div>
  );
};

export default memo(MenuBackdrop);
